import MessageService from 'message-service/message-service';
const pageUnits = [];

class GamedayAdsEngine {
    constructor({doubleClickMethodMap, config}) {
        this.doubleclick = doubleClickMethodMap;
        this.config = config;
        this.refreshAdList = [];
        this.refreshRate = this.config?.adRefreshRate ? (this.config?.adRefreshRate * 1000 ) : 60000;
        this.refreshInterval = undefined;
        this.init();
    }

    init() {
        
        this.drawAds();
    }

    drawAds() {
        const { responsive } = this.config;

        this.doubleclick.doubleclickListener('AD_THRESHOLD_CHANGE', function() {
            MessageService.publish('AD_THRESHOLD_CHANGE')}
        );

        this.doubleclick.initDoubleclick({
            pageUnits: pageUnits,
            doubleClickConfigObj: { ...this.config, ...{responsive: !!responsive}}
        });

    }

};

export default GamedayAdsEngine;